export const orgAssets = {
  title: "Assets",
  label: {
    noMoreAssets: "No more assets to load",
  },
  button: {
    createNewAsset: "Create New Asset",
    deleteAsset: "Delete Asset",
  }
}